/**
 * Persistenza del numero da prefillare nella barra SIP via localStorage.
 *
 * Necessario quando il popup è CHIUSO al momento del clic: window.open ha
 * bisogno di un momento per avviare la finestra, caricare il bundle e montare
 * i componenti. Il BroadcastChannel con postPrefillNumber arriva troppo presto
 * e viene perso. Qui depositiamo il numero in localStorage (condiviso
 * same-origin tra main app e popup), così SipBar.vue può riprenderlo
 * nell'onMounted.
 *
 * Il valore è "take once": la prima lettura lo consuma e lo rimuove, così
 * non persiste tra sessioni successive né viene riapplicato su un popup già
 * aperto che venga rimontato.
 */

const KEY = "sip-pending-prefill";

/**
 * Deposita il numero di telefono da prefillare nel localStorage.
 * Sicuro rispetto a policy di storage disabilitate (es. iframe con
 * storage bloccato, Safari private mode): in quel caso è un no-op.
 */
export function setPendingPrefill(phoneNumber: string): void {
  try {
    localStorage.setItem(KEY, phoneNumber);
  } catch {
    // storage disabled — ignore
  }
}

/**
 * Legge e rimuove il numero in sospeso dal localStorage.
 * Ritorna la stringa se presente, null altrimenti.
 * Idempotente: la seconda chiamata restituisce sempre null.
 */
export function takePendingPrefill(): string | null {
  try {
    const v = localStorage.getItem(KEY);
    if (v) localStorage.removeItem(KEY);
    return v;
  } catch {
    return null;
  }
}
